{
	"org-interpolations": {
		"default": {
			"caregivers": "Caregivers",
			"caregiver": "Caregiver",
			"care-recipients": "Care Recipients",
			"care-recipient": "Care Recipient"
		},
		"education": {
			"caregivers": "Teachers",
			"caregiver": "Teacher",
			"care-recipients": "Students",
			"care-recipient": "Student"
		}
	},
	"dialog": {
		"yes": "Yes",
		"no": "No"
	},
	"common": {
		"username": "Username",
		"first-name": "First name",
		"last-name": "Last name",
		"optional": "Optional",
		"cancel": "Cancel",
		"back": "Back",
		"skip": "Skip",
		"save": "Save",
		"search": "Search"
	},
	"contacts-select": {
		"input-search-label": "Find contacts",
		"list-title": "All Contacts"
	},
	"stepper": {
		"steps-of-total": "{{completed}} of {{total}}"
	},
	"profile-photo-picker": {
		"change-photo": "Change photo",
		"replace-photo": "Replace photo",
		"upload-photo": "Upload photo"
	},
	"editable-items": {
		"add-information": "Add information"
	},
	"edit-profile-form": {
		"critical": "Critical",
		"positive": "Preferences",
		"negative": "Challenges",
		"tooltip": {
			"critical": "Vital information to ensure safe and proper care",
			"positive": "{{care-recipient}}’s likes and interests to provide personalized care",
			"negative": "Things to be aware of to avoid discomfort"
		},
		"email": "Email",
		"about-me": "About me",
		"restricted-access": "Restricted Access"
	},
	"crop-photo-modal": {
		"title": "Adjust the photo area",
		"move-and-scale-the-photo": "Move and scale to select the area of the photo to use."
	},
	"table": {
		"no-data": "No data"
	},
	"error-boundary": {
		"whoops-something-went-wrong": "Whoops, something went wrong.",
		"please-either-refresh-the-page-or-try-again-later": "Please either refresh the page or try again later.",
		"refresh": "Refresh?"
	},
	"autocomplete-input": {
		"placeholder": "Type to search",
		"add-value": "Add \"{{value}}\""
	},
	"tags-editor": {
		"label": "Tags",
		"placeholder": "Type to search for tags",
		"add-tag": "Add tag \"{{value}}\""
	},
	"form-period-control": {
		"period": {
			"day_one": "{{count}} day",
			"day_other": "{{count}} days",
			"custom": "Custom"
		}
	}
}
